import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AgricultureToastType } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { Dialog } from 'app/agriculture/components/Dialog/Dialog';
import { ServicesContext } from 'app/items/shared/context_interface';
import { useEntityRemoveMutation } from 'app/agriculture/mutations/entity/remove/useEntityRemoveMutation';
import { useFarmPath } from 'app/agriculture/router/useFarmPath';

interface TaskDeleteDialogProps {
    taskId: string;
}

export function TaskDeleteDialog({ taskId }: TaskDeleteDialogProps) {
    const { agricultureToastService } = useContext(ServicesContext);
    const farmPath = useFarmPath();
    const navigate = useNavigate();
    const { mutate: deleteTask } = useEntityRemoveMutation('Task');

    function onError(error: Error) {
        navigate(-1);
        console.error('Error deleting task', error);
        agricultureToastService
            .showToast({
                title: 'Failed to delete task:',
                subtext: 'Something went wrong',
                type: AgricultureToastType.ERROR,
                variant: 'simple',
            })
            .catch((e) => {
                console.error(e);
            });
    }

    return (
        <Dialog
            disableCloseButton
            actions={{
                primaryAction: {
                    text: 'Delete it',
                    theme: 'danger',
                    onClick: () => {
                        navigate(farmPath('/'), { replace: true });
                        deleteTask(taskId, { onError });
                    },
                },
                backAction: {
                    startIcon: undefined,
                    text: 'Cancel',
                    variant: 'contained',
                    onClick: () => {
                        navigate(-1);
                    },
                },
            }}
        >
            Are you sure you want to delete this task?
        </Dialog>
    );
}
